import * as React from "react";
import cx from "classnames";

import Modal, { ModalProps } from "./Modal";
import "./ChoiceModal.css";

export interface ChoiceModalProps extends ModalProps {
  onConfirm: (event: React.SyntheticEvent<any>) => void;
  onCancel?: (event: React.SyntheticEvent<any>) => void;
  children: React.ReactChild | React.ReactChild[];
}

const getStyles = ({ bodyClassName }: Partial<ChoiceModalProps>) =>
  cx("choice-modal", bodyClassName);

const ChoiceModal = ({
  onConfirm,
  onCancel,
  children,
  ...modalProps,
}: ChoiceModalProps) => (
  <Modal {...modalProps} bodyClassName={getStyles(modalProps)}>
    {children}
    <div className="choice-modal__btn-container">
      <button
        className="choice-modal__btn choice-modal__confirm"
        onClick={onConfirm}
      >
        Ok
      </button>
      {onCancel && (
        <button
          className="choice-modal__btn choice-modal__cancel"
          onClick={onCancel}
        >
          Huỷ
        </button>
      )}
    </div>
  </Modal>
);

export default ChoiceModal;



// WEBPACK FOOTER //
// ./src/components/ChoiceModal.tsx